import { required, SelectInput } from 'react-admin';
import { useWatch } from 'react-hook-form';

import {
  classicInvestorProfileRiskProfileChoices,
  investorProfileRiskProfileChoices,
  SICAV_COMPATIBLE_CATEGORIES,
} from '@sh4res/bo-common/choices/investorProfile';
import { ShowSection } from '@sh4res/bo-common/components';

export const B2bInvestorProfileRiskProfileInput = ({ testId }: { testId: string }) => {
  const productCategory = useWatch({
    name: 'product_category',
  });

  return (
    <ShowSection
      sx={{ width: '100%' }}
      noCard={true}
      label="resources.bo_common.b2b.investor_profile.create.template">
      <SelectInput
        sx={{ width: '100%' }}
        source="grid_template"
        label="resources.bo_common.b2b.investor_profile.create.template"
        isRequired
        validate={[required()]}
        data-testid={testId}
        choices={
          SICAV_COMPATIBLE_CATEGORIES.includes(productCategory)
            ? investorProfileRiskProfileChoices
            : classicInvestorProfileRiskProfileChoices
        }
      />
    </ShowSection>
  );
};
